import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminTimesheetsPage from "@/pages/admin/AdminTimesheetsPage";

export const Route = createFileRoute("/_admin/admin/timesheets")({
  head: () => pageHead("Admin · Timesheets", "AKIVA admin · timesheets portal.", "/admin/timesheets", true),
  component: AdminTimesheetsPage,
});
